module.exports = "https://cdn.realtymogul.com/static/media/Jason_C.4ad54955.png";